import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoCircled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 15 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7.5.877a6.623 6.623 0 1 0 0 13.246A6.623 6.623 0 0 0 7.5.877M1.827 7.5a5.673 5.673 0 1 1 11.346 0 5.673 5.673 0 0 1-11.346 0m6.423-3a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M6 6h1.5a.5.5 0 0 1 .5.5V10h1v1H6v-1h1V7H6z",
		clipRule: "evenodd"
	})
});
const Memo = memo(SvgInfoCircled);
export default Memo;
